export const trimmer = (string, endIndex, endOfString = '') => {
  return `${string?.substring(0, endIndex)}${endOfString}`
}

export const conditionalTrimmer = (string, endIndex, endOfString = '') => {
  return string?.length > endIndex
    ? `${string?.substring(0, endIndex)}${endOfString}`
    : string
}
